export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const clampDiscount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
};

export const computeOfferPrices = (mrp, discountPercent, offerTypeKeys = []) => {
  const base = Number(mrp) || 0;
  const disc = clampDiscount(discountPercent);
  const prices = {};
  offerTypeKeys.forEach((key) => {
    if (!key || key === 'flat') return;
    prices[key] = round2(base * (1 - disc / 100));
  });
  return prices;
};

export const priceFromDiscount = (mrp, discountPercent) => {
  const base = Number(mrp) || 0;
  return round2(base * (1 - clampDiscount(discountPercent) / 100));
};

export const formatMoney = (value) =>
  (Number(value) || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
